<!-- 
AttentionModal.vue
功能：提醒事項視窗
作者：i9400538 陳博承
完成：2021-05-19
-->
<template>
  <div id="attention-modal" class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog" style="width: 900px;">
      <div class="modal-content">
        <div class="modal-header">
          <a @click="$emit('close')" class="close">
            <i class="icon-close"></i>
          </a>
          <div class="col-12 pl-0">
            <h3 class="modal-title">{{attentionName}}</h3>
          </div>
        </div>
        <div class="modal-body">
          <template v-if="attentionID=='injuryInsurance'">
            <div class="row">
              <!-- 傷害險續保增額提醒 -->
              <p class="text-red">※寄發給客戶的專函中(要保人歸戶)，服務件資訊提供參考，建議詳讀下方警語。</p>
              <table class="table insurance-green">
                <thead>
                  <tr>
                    <th id="th_policy_no" class="text-center">保單號碼</th>
                    <th id="th_renewal" class="text-center">續保日</th>
                    <th id="th_prod_sname" class="text-center">保險商品</th>
                    <th id="th_role_name" class="text-center">被保險人</th>
                    <th id="th_rd_amt" class="text-center">保額</th>
                    <th id="th_rd_prem" class="text-center">保費</th>
                    <th id="th_new_rd_amt" class="text-center">試算續保保額</th>
                    <th id="th_new_rd_prem" class="text-center">試算續保保費</th>
                    <th id="th_deadline" class="text-center">建議辦理期限</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-if="tableData.length > 0">
                    <tr v-for="(item, i) in tableData" :key="`table-item-attention-${i}`">
                      <td class="text-center">{{item.policy_no}}</td>
                      <td class="text-center">{{item.renewal}}</td>
                      <td class="text-center">{{item.prod_sname}}</td>
                      <td class="text-center">{{item.role_name}}</td>
                      <td class="text-center">{{item.rd_amt}}</td>
                      <td class="text-center">{{item.rd_prem}}</td>
                      <td class="text-center">{{item.new_rd_amt}}</td>
                      <td class="text-center">{{item.new_rd_prem }}</td>
                      <td class="text-center">{{item.deadline | dateFormat}}</td>
                    </tr>
                  </template>
                </tbody>
              </table>
              <p class="text-red">
                ※上表開放查詢至建議辦理期限之次月月底。
                <br />
                <br />※若客戶同意增額，建議於上表辦理期限前完成，以利後續其他流程處理。
                <span
                  class="text-black"
                >【續保日(不含)前可辦理，但為確保保費資料無時間差，建議於續保月前月第二週之週三(含)完成辦理】</span>
              </p>※請至「壽險核心系統＞保全系統＞附約變更＞傷害險調整作業」查詢客戶是否仍有尚未辦理傷害險增額的保單，若皆已辦理則不需重覆協助客戶辦理。
              <br />
              <br />※本次配合法令調整傷害險續保作業之相關資訊，請至「金控入口網站>商品專區>商品支援>傳統型保全保費支援>110年個人傷害保險調整專區」查詢。
              <p class="text-red">
                <span class="text-black">【本明細只要與客戶有經手/收費關係之保單均會呈現，然</span>傷害險增額辦理名單專區只會指派最新服務人員聯繫客戶辦理。
                <span class="text-black">因此若該客戶未出現在名單專區內，則無需聯繫客戶辦理】</span>
              </p>
            </div>
          </template>
          <template v-else-if="attentionID=='spilloverPolicy'">
            <!-- 外溢保單資訊查詢 -->
            <div class="row" :class="{'section-loading': is_loading_spilloverPolicy}">
              <span>外溢保單相關回饋為保戶權益，請務必向保戶說明各商品之外溢機制，並提醒保戶(被保險人)於指定期間完成回饋條件，以確保客戶權益，以下為實際年齡已適用條款約定外溢機制之保單：</span>
              <div v-for="(item, index) in tableData" :key="`table-item-pillover-nomal-${index}`">
                <span v-if="item.is_show" class="policy-no-text">#{{item.ceplcno}}</span>
                
                <!--會員點數型 -->
                <table v-if="isPointSpillover(item)" class="table insurance-green">
                  <thead>
                    <tr>
                      <th width="20%" :id="`th_point_prod_name_${index}`" class="text-center">投保商品</th>
                      <th width="15%" :id="`th_point_apc_name_${index}`" class="text-center">要保人</th>
                      <th width="15%" :id="`th_point_insd_name_${index}`" class="text-center">被保險人</th>
                      <th width="16%" :id="`th_point_is_cathay_member_${index}`" class="text-center">被保人是否為官網會員</th>
                      <th width="17%" :id="`th_point_spillover_memstl_point_date_${index}`" class="text-center">外溢點數回饋判斷日</th>
                      <th width="17%" :id="`th_point_is_cwp_member_${index}`" class="text-center">是否開通<br>「FitBack健康吧」</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="text-center">{{ item.prod_name }}</td>
                      <td class="text-center">{{ item.apc_name }}</td>
                      <td class="text-center">{{ item.insd_name }}</td>
                      <td class="text-center">{{ getShowText(item.is_cathay_member) }}</td>
                      <td class="text-center">{{ item.spillover_memstl_point_date | dateFormat }}</td>
                      <td class="text-center">{{ getShowText(item.is_cwp_member) }}</td>
                    </tr>
                  </tbody>
                </table>

                <table
                  class="table insurance-green"
                  v-else-if="item.is_increase_amt && item.is_increase_amt!='Y' && item.is_investment && item.is_investment!='Y' && item.is_weight && item.is_weight!='Y' && ((item.is_cancer_scerrn && item.is_cancer_scerrn !='N') || (item.is_health_check && item.is_health_check != 'N') || (item.is_smoking_cessation && item.is_smoking_cessation != 'N') || (item.is_vaccine && item.is_vaccine != 'N'))"
                >
                  <thead>
                    <tr>
                      <th width="20%" :id="`th_normal_prod_name_${index}`" class="text-center">投保商品</th>
                      <th width="10%" :id="`th_normal_apc_name_${index}`" class="text-center">要保人</th>
                      <th width="10%" :id="`th_normal_insd_name_${index}`" class="text-center">被保險人</th>
                      <th
                        width="12%"
                        :id="`th_normal_is_cathay_member_${index}`"
                        class="text-center"
                      >被保人是否為官網會員</th>
                      <th
                        width="13%"
                        :id="`th_normal_spillover_term_date_${index}`"
                        class="text-center"
                      >外溢回饋計算截止日</th>
                      <th
                        width="10%"
                        :id="`th_normal_is_cwp_member_${index}`"
                        class="text-center"
                      >是否開通「FitBack健康吧」</th>
                      <th
                        width="10%"
                        :id="`th_normal_health_check_doc_${index}`"
                        class="text-center"
                      >健檢報告證明文件</th>
                      <th
                        width="15%"
                        v-if="item.is_smoking_cessation == 'Y'"
                        :id="`th_normal_spillover_doc_${index}`"
                        class="text-center"
                      >疫苗接種/癌症篩選/戒菸醫療證明文件</th>
                      <th
                        v-else
                        width="15%"
                        :id="`th_normal_spillover_doc_${index}`"
                        class="text-center"
                      >疫苗接種/癌症篩檢證明文件</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="text-center">{{item.prod_name}}</td>
                      <td class="text-center">{{item.apc_name}}</td>
                      <td class="text-center">{{item.insd_name}}</td>
                      <td class="text-center">{{getShowText(item.is_cathay_member)}}</td>
                      <td class="text-center">{{item.spillover_term_date | dateFormat}}</td>
                      <td class="text-center">{{getShowText(item.is_cwp_member)}}</td>
                      <td class="text-center">{{getUploadStatusText(item.health_check_doc)}}</td>
                      <td class="text-center">{{getUploadStatusText(item.spilloverall_doc)}}</td>
                    </tr>
                  </tbody>
                </table>
                <!--會員型/增額型/投資型/減重型-->
                <table v-else class="table insurance-green">
                  <thead>
                    <tr>
                      <th :id="`th_investment_prod_name_${index}`" class="text-center">投保商品</th>
                      <th
                        width="15%"
                        :id="`th_investment_apc_name_${index}`"
                        class="text-center"
                      >要保人</th>
                      <th
                        width="15%"
                        :id="`th_investment_insd_name_${index}`"
                        class="text-center"
                      >被保險人</th>
                      <th
                        :id="`th_investment_is_cathay_member_${index}`"
                        class="text-center"
                      >被保人是否為官網會員</th>
                      <th
                        v-if="item.is_increase_amt=='Y'"
                        :id="`th_investment_spillover_term_date_${index}`"
                        class="text-center"
                      >外溢回饋計算截止日</th>
                      <th
                        v-else-if="item.is_spillover_prod=='Y' && item.is_membership=='Y' && item.is_investment =='N'"
                        :id="`th_is_membership_spillover_memstl_date_${index}`"
                        class="text-center"
                      >次年度外溢回饋判斷日</th>
                      <th :id="`th_investment_is_cwp_member_${index}`" class="text-center">是否開通「FitBack健康吧」</th>
                      <th
                        :id="`th_weight_spillover_term_date_${index}`"
                        v-if="item.is_weight=='Y'"
                        class="text-center"
                      >本保單年度上傳截止日</th>
                      <th
                        :id="`th_weight_doc_${index}`"
                        v-if="item.is_weight=='Y'"
                        class="text-center"
                      >體重證明文件</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="text-center">{{item.prod_name}}</td>
                      <td class="text-center">{{item.apc_name}}</td>
                      <td class="text-center">{{item.insd_name}}</td>
                      <td class="text-center">{{getShowText(item.is_cathay_member)}}</td>
                      <td
                        v-if="item.is_increase_amt=='Y'"
                        class="text-center"
                      >{{item.spillover_term_date | dateFormat}}</td>
                      <td
                        v-else-if="item.is_spillover_prod=='Y' && item.is_membership=='Y' && item.is_investment =='N'"
                        class="text-center"
                      >{{item.spillover_memstl_date | dateFormat}}</td>
                      <td class="text-center">{{getShowText(item.is_cwp_member)}}</td>
                      <td
                        v-if="item.is_weight=='Y'"
                        class="text-center"
                      >{{item.spillover_term_date | dateFormat}}</td>
                      <td
                        v-if="item.is_weight=='Y'"
                        class="text-center"
                      >{{getUploadStatusText(item.weight_doc)}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <!--連結區塊-->
            <div :class="{'section-loading': is_loading_spilloverPolicy}">
              <table id="linkTable">
                <tr>
                  <td>
                    <span class="share-link-title">推薦開通「FitBack健康吧」連結:</span>
                  </td>
                  <td>
                    <input
                      type="text"
                      style="position:absolute;left:-10000px;top:-10000px"
                      id="copyText"
                    />
                    <button
                      type="button"
                      class="btn btn-default btn-sm"
                      @click="copy(mmlUrl_cwp)"
                    >複製連結</button>
                  </td>
                  <td>
                    <i
                      class="icon-facebook share-link-click"
                      @click="encodeLink('fb', fbMetaUrl_cwp)"
                    ></i>
                  </td>
                  <td>
                    <i class="icon-line share-link-click" @click="encodeLink('line', mmlUrl_cwp)"></i>
                  </td>
                </tr>
              </table>
              <!--分享連結使用 -->
              <share-link-use
                title="外溢報告上傳連結:"
                content="點擊連結前往國泰人壽外溢保單證明文件上傳專區"
                mmlUrl="點擊連結前往國泰人壽外溢保單證明文件上傳專區：https://cathaylife.tw/mbq1ml"
                fbMetaUrl="https://cathaylife.tw/mbq1ml"
              />
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { commonMixin } from "@/mixins/common";
//service
import { getSpilloverInfo } from "@/service";
//component
import ShareLinkUse from "@/desktop/components/ShareLinkUse";
export default {
  name: "AttentionModal",
  mixins: [commonMixin],
  components: { ShareLinkUse },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    attentionID: {
      type: String,
      default: ""
    },
    attentionName: {
      type: String,
      default: ""
    },
    attention: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  computed: {
    ...mapGetters(["UserInfo"]),
    isBox() {
      // 判斷是否為 box
      return this.UserInfo.userType === "box";
    }
  },
  data() {
    return {
      tableData: [],
      is_loading_spilloverPolicy: false,
      mmlUrl_cwp: "",
      fbMetaUrl_cwp: "",
      metainfoContent: ""
    };
  },
  watch: {
    open: function(val) {
      if (val == true) {
        if (this.attentionID == "spilloverPolicy") {
          this.getSpilloverinfo_attention();
        } else {
          this.tableData = this.attention;
        }
        this.registerHanlink();
      }
    }
  },
  metaInfo() {
    return {
      meta: [
        { property: "og:type", content: "website" },
        { property: "og:url", content: this.fbMetaUrl },
        {
          property: "og:description",
          content:
            "揪你加入「FitBack健康吧」健康計劃，點連結下載(開啟)國泰人壽APP並登入，再依步驟開通就可以囉！"
        }
      ]
    };
  },
  methods: {
    //判斷是line還是FB
    encodeLink(type, link) {
      if (this.isBox) {
        this.boxCathayShareLink(link);
      } else {
        let str = encodeURI(link);
        let url =
          type === "fb"
            ? `http://www.facebook.com/share.php?u=${str}`
            : `http://line.naver.jp/R/msg/text/?${str}`;
        window.open(url);
      }
    },
    //複製連結
    copy(url) {
      if (this.isBox) {
        this.boxCathayShareLink(url);
      } else {
        const copyText = document.getElementById("copyText");
        copyText.value = url;
        copyText.select();
        copyText.setSelectionRange(0, 99999);
        if (document.execCommand("cut")) {
          this.$toast.info({ title: "連結已複製" });
        } else {
          console.error("複製失敗");
        }
      }
    },
    //外溢保單資訊查詢
    getSpilloverinfo_attention() {
      this.is_loading_spilloverPolicy = true;
      getSpilloverInfo(this.$store.state.userInfo.id, this.attention).then(
        result => {
          this.is_loading_spilloverPolicy = false;
          if (result.header && result.header.status == "200") {
            let inviteUrl =
              result.body.invite_url || "https://cathaylife.tw/VgA6jo";
            this.mmlUrl_cwp =
              "揪你加入「FitBack健康吧」健康計劃，點連結下載(開啟)國泰人壽APP並登入，再依步驟開通就可以囉！ " +
              inviteUrl;
            this.fbMetaUrl_cwp = inviteUrl;
            this.tableData = result.body.spillover_list;
          } else {
            this.mmlUrl_cwp =
              "揪你加入「FitBack健康吧」健康計劃，點連結下載(開啟)國泰人壽APP並登入，再依步驟開通就可以囉！ https://cathaylife.tw/VgA6jo";
            this.tableData = this.attention;
          }
          this.registerHanlink();
        }
      );
    },
    // 會員點數型
    isPointSpillover(item) {
      return (
        item.is_spillover_prod === 'Y' &&
        item.is_increase_amt === 'N' &&
        item.is_premium_reduce === 'N' &&
        item.is_investment === 'N' &&
        item.is_health_check === 'N' &&
        item.is_cancer_scerrn === 'N' &&
        item.is_vaccine === 'N' &&
        item.is_smoking_cessation === 'N' &&
        item.is_membership === 'Y' &&
        item.is_weight === 'N' &&
        item.is_point === 'Y'
      );
    },
    //取得顯示文字(Y/N轉換)
    getShowText(val) {
      let text = "";
      if (!val || !val.trim()) {
        return text;
      }
      if (val == "Y") {
        text = "是";
      } else {
        text = "否";
      }
      return text;
    },
    //上傳資料狀態對照
    getUploadStatusText(val) {
      let text = "";
      if (!val || !val.trim()) {
        return text;
      }
      if (val == "00") {
        text = "未上傳";
      } else if (val == "01") {
        text = "審核中";
      } else if (val == "02") {
        text = "審核未過，重新上傳";
      } else if (val == "03") {
        text = "已上傳成功";
      }
      return text;
    },
  }
};
</script>
<style lang="scss" scoped>
.text-black {
  color: black;
}
.share-link-title {
  font-weight: 600;
  font-size: 20px;
}
.share-link-click {
  cursor: pointer;
}
.policy-no-text {
  font-weight: 600;
  font-size: 26px;
}
</style>